export default __webpack_public_path__ + "static/media/share.9d334fe4.svg";